import {without} from 'lodash';

import {InteractiveChatAction} from 'types';

// LLM chatbots with identical node behavior (children: CallAgent + AsyncRequest;
// RequestAppointment/CallAgentConfirm fire automatically via classification).
// Add a new LLM provider here so the tree editor handles it like the others.
export const LLM_CHATBOT_ACTIONS = [
    InteractiveChatAction.ChatGpt,
    InteractiveChatAction.Claude,
    InteractiveChatAction.Mastra,
];

export const ROOT_NODES_ACTIONS = [
    InteractiveChatAction.ChatGpt,
    InteractiveChatAction.Claude,
    InteractiveChatAction.Mastra,
    InteractiveChatAction.Tree,
    InteractiveChatAction.Watsonx,
    InteractiveChatAction.InternalLiveAgent,
    InteractiveChatAction.AsyncRequest,
];
export const NODE_CHILD_ACTIONS = {
    [InteractiveChatAction.ChatGpt]: [InteractiveChatAction.CallAgent, InteractiveChatAction.AsyncRequest],
    [InteractiveChatAction.Claude]: [InteractiveChatAction.CallAgent, InteractiveChatAction.AsyncRequest],
    [InteractiveChatAction.Mastra]: [InteractiveChatAction.CallAgent, InteractiveChatAction.AsyncRequest],
    [InteractiveChatAction.Watsonx]: [InteractiveChatAction.CallAgent],
    [InteractiveChatAction.InternalLiveAgent]: [InteractiveChatAction.CallAgent],
    [InteractiveChatAction.AsyncRequest]: [
        InteractiveChatAction.CallAgent,
        InteractiveChatAction.RequestAppointment,
        InteractiveChatAction.Tree
    ],
    [InteractiveChatAction.Tree]: without(
        Object.values(InteractiveChatAction),
        InteractiveChatAction.CallAgentConfirm,
    )
};